import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import { ContentCard } from "@/components/ContentCard";

export const ContentRow = ({ title, items, wide = false, seeAll = null }) => {
  const ref = useRef(null);
  if (!items?.length) return null;

  const scroll = (dir) => {
    ref.current?.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className="relative group/row" data-testid="content-row">
      <div className="flex items-center justify-between mb-3 px-4 sm:px-8 lg:px-12">
        <h2 className="text-lg sm:text-2xl font-head font-bold">{title}</h2>
        {seeAll && (
          <Link to={seeAll} data-testid="row-see-all"
            className="shrink-0 flex items-center gap-1 text-xs sm:text-sm font-semibold text-zinc-400 hover:text-white transition-colors">
            See all <ArrowRight size={14} />
          </Link>
        )}
      </div>
      <button onClick={() => scroll(-1)}
        className="hidden md:grid place-items-center absolute left-0 top-[52%] z-30 w-12 h-24 bg-gradient-to-r from-black/80 to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity">
        <ChevronLeft size={30} />
      </button>
      <div ref={ref} className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-hide px-4 sm:px-8 lg:px-12 pb-2">
        {items.map((it) => <ContentCard key={it.id} item={it} wide={wide} />)}
      </div>
      <button onClick={() => scroll(1)}
        className="hidden md:grid place-items-center absolute right-0 top-[52%] z-30 w-12 h-24 bg-gradient-to-l from-black/80 to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity">
        <ChevronRight size={30} />
      </button>
    </section>
  );
};
